var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightenImg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 114,
    viewBox: "0 0 192 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3996 46.6626C73.7079 46.6626 66.6619 39.6166 66.6619 30.9249V16.2231C66.6619 7.53136 59.6159 0.485353 50.9242 0.485353L15.7378 0.485352C7.04606 0.485351 4.54684e-05 7.53136 4.50885e-05 16.2231L4.37579e-05 46.6626C4.37579e-05 46.6626 3.39624e-05 46.6626 2.18789e-05 46.6626C9.79554e-06 46.6626 0 46.6626 0 46.6626V97.5867C0 106.278 7.046 113.324 15.7377 113.324H176.262C184.954 113.324 192 106.278 192 97.5868V62.4003C192 53.7086 184.954 46.6626 176.262 46.6626H82.3996Z",
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightenImg1);
export default __webpack_public_path__ + "static/media/brighten-img-1.dfb45eb6325b66d593171ac8e49a99c2.svg";
export { ForwardRef as ReactComponent };